// Brand scene imagery, not customer albums or a list of serviced locations.
export const MEMORIES = {
  'mountain-solo': {
    label: '山野 · 独自出发',
    alt: '背着小背包的旅行者在山间观景台回眸微笑，身后是层叠青山。',
  },
  'river-couple': {
    label: '水乡 · 两个人的路',
    alt: '情侣牵手走过水乡石桥，相视而笑，河水映着两岸的老屋。',
  },
  'lake-partners': {
    label: '湖畔 · 身边是你',
    alt: '夫妻在湖畔并肩散步，望向彼此微笑，远处是湖水和青山。',
  },
  'sea-family': {
    label: '海边 · 一家人的夏天',
    alt: '父母牵着孩子在海边散步，一家三口都笑着留在画面里。',
  },
  'forest-family': {
    label: '山林 · 一起慢慢走',
    alt: '父母陪着孩子走在洒满阳光的林间步道上，边走边聊。',
  },
  'oldtown-solo': {
    label: '古镇 · 遇见好时光',
    alt: '独自旅行的年轻人在古镇街角回头，身后是木门、石路与水巷。',
  },
  'lake-family': {
    label: '湖上 · 同看一片山水',
    alt: '一家人在有护栏的游船上眺望湖光山色，孩子指向远山，父母微笑。',
  },
  'sea-couple': {
    label: '海风 · 喜欢的人在身边',
    alt: '情侣在海边步道牵手漫步，海风吹起发梢，两人自然地笑着。',
  },
  'sea-solo': {
    label: '看海 · 和自己相处',
    alt: '戴草帽的旅行者独自走在海岸边，迎着柔和的海风回眸微笑。',
  },
  'oldtown-partners': {
    label: '街巷 · 并肩走过',
    alt: '夫妻穿着日常便装并肩走过古镇街巷，在温暖的光线里相视而笑。',
  },
  'park-family': {
    label: '日常 · 三代人的好时光',
    alt: '外婆、妈妈和孩子一起漫步湖边公园，在树荫下牵手说笑。',
  },
  cycling: {
    label: '骑行 · 迎着风出发',
    alt: '戴着头盔的骑行者迎着林间阳光向前，身后的道路与山林充满生机。',
  },
  'trail-running': {
    label: '越野 · 跑进山野',
    alt: '越野跑者沿着山林小径向前奔跑，阳光照亮了脚下的路。',
  },
  marathon: {
    label: '奔跑 · 笑着抵达',
    alt: '马拉松跑者在终点区域张开双臂，露出完成比赛后的笑容。',
  },
  'morning-run': {
    label: '晨跑 · 追一束晨光',
    alt: '跑者在清晨的湖畔迎着晨光迈开脚步，湖水与树木在身后展开。',
  },
  motorcycling: {
    label: '摩托 · 迎向下一程',
    alt: '穿着完整护具的摩托车手经过赛道弯道，专注地驶向前方。',
  },
} as const;
export type MemoryId = keyof typeof MEMORIES;
export const WALL_COLUMNS: ReadonlyArray<
  ReadonlyArray<{ id: MemoryId; portrait?: boolean; tilt: number; order: number }>
> = [
  [
    { id: 'mountain-solo', portrait: true, tilt: -4, order: 0 },
    { id: 'forest-family', tilt: 3, order: 8 },
    { id: 'trail-running', tilt: -2, order: 11 },
    { id: 'oldtown-solo', tilt: 3, order: 14 },
  ],
  [
    { id: 'river-couple', tilt: 3, order: 1 },
    { id: 'cycling', portrait: true, tilt: -3, order: 4 },
    { id: 'lake-family', tilt: 2, order: 9 },
    { id: 'sea-solo', tilt: -3, order: 12 },
  ],
  [
    { id: 'lake-partners', portrait: true, tilt: -2, order: 2 },
    { id: 'oldtown-partners', tilt: 4, order: 7 },
    { id: 'marathon', tilt: -3, order: 10 },
    { id: 'park-family', tilt: 2, order: 15 },
  ],
  [
    { id: 'sea-family', tilt: 4, order: 3 },
    { id: 'sea-couple', portrait: true, tilt: -3, order: 6 },
    { id: 'morning-run', tilt: 3, order: 5 },
    { id: 'motorcycling', tilt: -2, order: 13 },
  ],
];
export function memorySources(id: MemoryId) {
  const base = `/images/memories-v1/${id}`;
  return {
    src: `${base}-768.webp`,
    srcSet: `${base}-384.webp 384w, ${base}-768.webp 768w`,
    avif: `${base}-384.avif 384w, ${base}-768.avif 768w`,
  };
}
